<template>
  <v-container fluid py-0>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-container fluid pt-0>
          <v-row align="center">
            <div>
              <h1 class="headline">Agent Types</h1>
            </div>
            <div>
              <v-tooltip
                v-if="$store.getters.hasAccessTo('agents:create_agent')"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="ml-2"
                    fab
                    dark
                    color="primary"
                    @click="onCreateNew"
                  >
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Create New Agent Type</span>
              </v-tooltip>
            </div>
          </v-row>
        </v-container>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="$apollo.loading"
      :search="search"
      item-key="id"
      class="elevation-1"
      v-bind="pagingOptions"
      fixed-header
      hide-default-footer
      @update:options="onListOptionsUpdate"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
    >
      <template v-slot:item.notInUse="{ item }">
        <v-simple-checkbox
          v-model="item.notInUse"
          :disabled="true"
        ></v-simple-checkbox>
      </template>
      <template v-slot:item.actions="{ item }">
        <default-list-actions
          :item="item"
          :hide-view="true"
          :hide-remove="hideRemove"
          :hide-edit="hideEdit"
          @deleteItem="deleteItem"
          @editItem="editItem"
        ></default-list-actions>
      </template>
    </v-data-table>

    <get-more-results
      :first="first"
      @limitChange="onLimitChange"
      :items="agentTypes"
      :totalItems="totalItems"
      :loading="$apollo.loading"
      :loadMoreEnabled="loadMoreEnabled"
      @loadMore="loadMore('agentTypes')"
    ></get-more-results>
    <edit-agent-type-dialog
      v-model="editedAgentType"
      :show="showAgentTypeEditor"
      @close="showAgentTypeEditor = false"
      @input="onSave"
    ></edit-agent-type-dialog>
  </v-container>
</template>
<script>
import { ListMixin } from "../../../mixins/ListMixin";
import { ALL_AGENT_TYPES_SEARCH_QUERY } from "../../../constants/graphql";
import GetMoreResults from "../shared/GetMoreResults";
import DefaultListActions from "../shared/DefaultListActions";
import EditAgentTypeDialog from "./EditAgentTypeDialog";
import { removeGQLTypename } from "../../../helpers";
import gql from "graphql-tag";

const DELETE_MUTATION = gql`
  mutation deleteAgentType($id: ID!) {
    deleteAgentType(id: $id) {
      id
    }
  }
`;
const CREATE_MUTATION = gql`
  mutation createAgentType($input: AgentTypeInput!) {
    createAgentType(input: $input) {
      id
      name
      notInUse
    }
  }
`;
const UPDATE_MUTATION = gql`
  mutation updateAgentType($id: ID!, $input: AgentTypeInput!) {
    updateAgentType(id: $id, input: $input) {
      id
      name
      notInUse
    }
  }
`;

export default {
  name: "AgentTypesList",

  props: {
    refName: {
      type: String,
      default: () => "agent-types-list",
    },
  },

  mixins: [ListMixin],

  components: {
    GetMoreResults,
    DefaultListActions,
    EditAgentTypeDialog,
  },

  data() {
    return {
      agentTypes: {},
      editedAgentType: {},
      showAgentTypeEditor: false,
      headers: [
        {
          text: "Name",
          value: "name",
          name: "name",
        },
        {
          text: "Not In Use",
          value: "notInUse",
          name: "notInUse",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
    };
  },

  computed: {
    items() {
      return this.agentTypes && this.agentTypes.edges
        ? this.agentTypes.edges.map(removeGQLTypename)
        : [];
    },
    hideRemove() {
      return !this.$store.getters.hasAccessTo("agents:delete_agent");
    },
    hideEdit() {
      return !this.$store.getters.hasAccessTo("agents:edit_agent");
    },
  },

  methods: {
    async onSave(payload) {
      this.showAgentTypeEditor = false;
      const { id, ...input } = payload;
      const mutation = payload.id ? UPDATE_MUTATION : CREATE_MUTATION;
      try {
        const mutationRes = await this.$apollo.mutate({
          mutation: mutation,
          variables: { input: { ...input }, id },
        });
        this.$apollo.queries.agentTypes.refetch();
        this.$store.dispatch("showAppSnackbar", {
          msg: "Agent Type saved.",
        });
      } catch (error) {
        console.log(error);
      }
    },

    editItem(item) {
      this.editedAgentType = { ...item };
      this.showAgentTypeEditor = true;
    },
    onCreateNew() {
      this.editedAgentType = { name: "New Agent Type" };
      this.showAgentTypeEditor = true;
    },
    deleteItem(item) {
      this.$apollo
        .mutate({
          mutation: DELETE_MUTATION,
          variables: {
            id: item.id,
          },
        })
        .then(this.removeGqlObjectHandler, this.removeGqlObjectErrorHandler);
    },
    removeGqlObjectHandler(result) {
      this.$store.dispatch("showAppSnackbar", { msg: "Agent Type removed." });

      if (this.$apollo.queries.agentTypes != null) {
        this.$apollo.queries.agentTypes.refetch();
      }
    },
    removeGqlObjectErrorHandler(err) {
      const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
      this.$store.dispatch("showAppSnackbar", {
        msg: errorMsg,
        color: "error",
      });
      //console.log(err);
    },
  },

  apollo: {
    agentTypes: {
      query: ALL_AGENT_TYPES_SEARCH_QUERY,
      variables() {
        return {
          after: this.after,
          sort: this.sort,
        };
      },
      fetchPolicy: "network-only",
      result({ data, loader, networkStatus }) {
        this.totalItems = data.agentTypes.totalCount;
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/agents/AgentTypesList.vue